import { render, staticRenderFns } from "./CustomTable.vue?vue&type=template&id=5bbb8cbc&scoped=true"
import script from "./CustomTable.vue?vue&type=script&lang=js"
export * from "./CustomTable.vue?vue&type=script&lang=js"
import style0 from "./CustomTable.vue?vue&type=style&index=0&id=5bbb8cbc&prod&lang=css"
import style1 from "./CustomTable.vue?vue&type=style&index=1&id=5bbb8cbc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbb8cbc",
  null
  
)

export default component.exports